var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTens(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_469_7198)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.9365 3.00666C17.8196 1.13648 15.0402 0 12.0003 0C8.17014 0 4.75389 1.80412 2.55536 4.60683C2.497 4.68122 2.52437 4.79175 2.61076 4.83009C4.60065 5.71214 7.27417 6.2107 10.086 6.2107C14.9845 6.2107 18.6106 4.7603 19.9495 3.21295C20.0021 3.15211 19.9967 3.05991 19.9365 3.00666Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8056 16.7266C22.8049 16.7266 22.8041 16.7266 22.8033 16.7266C19.1849 16.7266 15.7536 17.6969 13.1415 19.4588C11.3901 20.6401 10.1803 22.0886 9.64729 23.5954C9.61729 23.6803 9.66843 23.773 9.75688 23.7898C10.4838 23.9278 11.2336 24.0001 12 24.0001C16.8598 24.0001 21.0536 21.096 22.9385 16.9323C22.9819 16.8363 22.9109 16.7267 22.8056 16.7266Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.585 4.78882C21.5312 4.71738 21.425 4.71096 21.3635 4.77588C19.327 6.92224 14.999 8.30997 10.0857 8.30997C6.84844 8.30997 3.73795 7.69183 1.44398 6.60382C1.37194 6.56969 1.28564 6.59843 1.25011 6.66982C0.450141 8.27641 0 10.0867 0 12.0001C0 17.0023 3.07678 21.2994 7.43719 23.0986C7.51556 23.131 7.60406 23.0888 7.6312 23.0085C8.29767 21.0346 9.79805 19.1818 11.9677 17.7185C14.9228 15.7252 18.771 14.6275 22.8033 14.6275C23.064 14.6275 23.3241 14.6325 23.5836 14.6412C23.6542 14.6436 23.7169 14.5956 23.7318 14.5265C23.9071 13.7117 24 12.8666 24 12.0001C24 9.29561 23.1002 6.79774 21.585 4.78882Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_469_7198"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTens);
export default __webpack_public_path__ + "static/media/TENS.c9cfaf1cca214645630c9fa8f7e04032.svg";
export { ForwardRef as ReactComponent };